<template>
    <div class="ghCTA gh-bg-lightBlue">
        <div class="container">
            <el-row :gutter="1">
                <el-col>
                    <div>
                        <div class="gh-cta gh-white">LIVE&nbsp;&nbsp; <span>10-11 Sep 2022</span></div>
                        <div class="gh-cta gh-white">ON-DEMAND&nbsp;&nbsp; <span>12 Sep - 6 Nov<span class="gh-desktop"></span> 2022</span></div>
                    </div>
                    <el-button class="gh-bg-lightPink gh-white" @click="scrollToSection('registration')">
                        Register Now
                    </el-button>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import UX from '@/utils/ux';

export default {
    methods: {
        scrollToSection(section) {
            const element = document.getElementById(section);
            element && UX.scrollTo(element);
            this.$emit('clicked');
        }
    }
}
</script>

<style lang="scss" scoped>
    .ghCTA {
        font-family: proxima-nova,sans-serif !important;
        background-image: linear-gradient(to right,#61B3E4,#64A3D8,#63A7DC,#648EC9,#627CBC,#626BB3);
        .container {
            padding: 20px;
            @media (max-width: 767px) {
                padding: 10px 0;
            }
        }
        span {
            font-weight: bold !important;
        }
        .el-row {
            .el-col {
                color: white;
                font-size: 1.2rem;
                text-align: center;
                display: flex;
                flex-flow: column;
                align-items: center;
                justify-content: center;
                .el-button {
                    border: none;
                    font-size: 1.35rem;
                    padding: .5rem 2rem;
                    transition: .3s;
                    margin-top: .5rem;
                    background-color: #F76C6C;
                    color: #fff;
                    &:hover {
                        color: white;
                        background-color: #ffaa98
                    }
                }
            }
        }
        .gh-cta {
            text-align: center;
            border-radius: 5px;
            display: inline-block;
            // background-color: #64A4D9;
            // font-size: 0.9rem;
            padding: 2px 6px;
            margin: auto 3px;
            @media (min-width: 768px) {
                // border: 1px solid #fdca30;
                font-size: 1.5rem;
                padding: 10px 20px;
                margin: auto 10px;
            }
            @media (min-width: 1024px) {
                font-size: 1.6rem;
            }
        }

        @media screen and (min-width: '1024px') {
            .el-row {
                .el-col {
                    font-size: 1.45rem;
                    flex-flow: row nowrap;
                    .el-button {
                        padding: .8rem 3rem;
                        margin-top: 0;
                        margin-left: 1rem;
                    }
                }
            }
            .gh-cta-1 {
                text-align: right;
            }
            .gh-cta-2 {
                text-align: center;
            }
            .gh-cta-3 {
                text-align: left;

            }
            .gh-cta-4 {
                margin-left: -.85rem;
                text-align: left;

            }
        }

        @media screen and (max-width: '375px') {
            .gh-desktop {
                display: none;
            }
        }
    }

    @media screen and (max-width: '375px') {
        .gh-desktop {
            display: none;
        }
    }
</style>
